import {
  INVALID_ONE_TIME_PASSWORD,
  INVALID_ONE_TIME_PASSWORD_SCD_ERROR,
  INVALID_USERNAME_OR_PASSWORD,
  INVALID_USERNAME_PASSWORD_SCD_ERROR,
  SOMETHING_WENT_WRONG,
  SOMETHING_WENT_WRONG_SCD_ERROR,
} from '~utils/constants'

export const groupChannelsByPhoneNumber = availableChannels => {
  let OTPGroups
  availableChannels.forEach(channel => {
    if (channel.phoneNumber) {
      let phoneExists = false

      OTPGroups?.forEach((phoneRadioItem, index, originalItem) => {
        // Find if there is already an object for the same phone number on a different channel.
        const phoneIndex = phoneRadioItem.findIndex(
          item => item.phoneNumber === channel.phoneNumber
        )

        //If there is an object or if the phone type is not new, push the channel object to the sub-array of the same phone number
        if (phoneIndex !== -1 && phoneRadioItem.length < 2) {
          phoneExists = true
          phoneRadioItem = phoneRadioItem.concat([channel])
          originalItem[index] = phoneRadioItem
        }
      })

      // If no sub-arrays exist, create a new sub-array and append the channel object
      if (!OTPGroups) {
        OTPGroups = [[channel]]
      } else if (!phoneExists) {
        // If no sub-array with the same phone number exists and if the phone type is new, create a new sub-array with the channel object
        OTPGroups = OTPGroups.concat([[channel]])
      }
    } else if (channel.email) {
      // If no sub-arrays exist, create a new sub-array and append the channel object
      // If no sub-array with the same phone number exists, create a new sub-array with the channel
      if (!OTPGroups) {
        OTPGroups = [[channel]]
      } else {
        OTPGroups = OTPGroups.concat([[channel]])
      }
    }
  })
  return OTPGroups
}

export const getErrorTemplate = error => {
  switch (error) {
    case INVALID_USERNAME_OR_PASSWORD:
      return INVALID_USERNAME_PASSWORD_SCD_ERROR
    case INVALID_ONE_TIME_PASSWORD:
      return INVALID_ONE_TIME_PASSWORD_SCD_ERROR
    case SOMETHING_WENT_WRONG:
      return SOMETHING_WENT_WRONG_SCD_ERROR
    default:
      return error
  }
}
